import { fork } from 'redux-saga/effects';
import { trainingsListSaga } from '../pages/TrainingsList/redux';

export function* rootSaga() {
  yield fork(trainingsListSaga);
}
